__turbopack_context__.v({
  "btn": "customStyles-module-scss-module__nxiu5G__btn",
  "customCardContainer": "customStyles-module-scss-module__nxiu5G__customCardContainer",
  "customCompatibilityLinkContainer": "customStyles-module-scss-module__nxiu5G__customCompatibilityLinkContainer",
  "customInvestorEmailVerificationContainer": "customStyles-module-scss-module__nxiu5G__customInvestorEmailVerificationContainer",
  "customSecondaryText": "customStyles-module-scss-module__nxiu5G__customSecondaryText",
  "terms": "customStyles-module-scss-module__nxiu5G__terms",
});
